<template>
  <div class="kiosk_cash_deposit" v-if="cashDepositAtKiosk">
    <div  class="kiosk_cash_deposit_holder">
      <h1 class="text_aligncenter">{{ $t('MyAccount.DepositAtKiosk') }}</h1>

      <div v-if="generatingTokenInProgress">
        <circle-loader></circle-loader>
      </div>

      <div v-if="!generatingTokenInProgress" class="get_token_holder">
        <template v-if="depositToken">
          <div class="auth_code_title">{{ $t('MyAccount.DepositAtKiosk.AuthCode') }}</div>
          <div class="token">{{ depositToken }}</div>
          <div class="countDownHolder" v-if="countDown && countDown > 0">
            <span class="expires_in">{{ $t('MyAccount.DepositAtKiosk.ExpiresIN') }}</span>
            <div v-if="countDown === 60" class="counter">01:00</div>
            <div v-else-if="countDown < 10" class="counter">00:0{{countDown}}</div>
            <div v-else class="counter">00:{{countDown}}</div>
          </div>
          <div class="auth_code_desc">{{ $t('MyAccount.DepositAtKiosk.AuthCodeDesc') }}</div>
        </template>
        <template v-if="!depositToken">
          <v-btn class="primary-btn"  @click="getToken()">{{ $t('MyAccount.DepositAtKiosk.GetToken') }}</v-btn>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import Screen from '@/components/mixins/Screen'
// import config from '@/config'
import store from '@/store'
import Branding from '@/components/mixins/Branding'
import CircleLoader from '@/components/common/CircleLoader'
import dotsLoader from '@/components/common/DotsLoader'

export default {
  components: {
    CircleLoader,
    dotsLoader
  },
  mixins: [
    Screen,
    Branding
  ],
  data: () => ({
    countDownTimeout: 0,
    countDown: 0
  }),
  computed: {
    cashDepositAtKiosk () {
      return window.ctsautoconf.CASH_DEPOSIT_AT_KIOSK || false
    },
    generatingTokenInProgress () {
      return store.getters['getKisokDepositGeneratingTokenInProgress']
    },
    tokenExpiryDateTime () {
      return store.getters['getKioskDepositTokenExpiryDateTime']
    },
    depositToken () {
      return store.getters['getKioskDepositToken']
    },
    tokenExpiration () {
      if (this.tokenExpiryDateTime) {
        let startDate = new Date()
        let endDate = new Date(this.tokenExpiryDateTime)
        let seconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000)
        return seconds
      }
    }
  },
  methods: {
    getToken () {
      store.dispatch('getTokenForDepositFromKiosk')
    },
    countDownTimer () {
      if (this.countDown > 0) {
        this.countDownTimeout = setTimeout(() => {
          this.countDown--
          this.countDownTimer()
        }, 1000)
      } else {
        clearTimeout(this.countDownTimeout)
        store.commit('setKioskDepositToken', null)
        store.commit('setKioskDepositTokenExpiryDateTime', null)
      }
    }
  },
  mounted () {
    store.commit('setKioskDepositToken', null)
    store.commit('setKioskDepositTokenExpiryDateTime', null)
  },
  watch: {
    depositToken (newVal) {
      if (newVal) {
        this.countDown = this.tokenExpiration
        this.countDownTimer()
      }
    }
  },
  created () {
  }
}
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"
  .text_aligncenter
    text-align center
    margin 10px 0 0 0 !important
  .get_token_holder
    text-align center
    padding 50px 20px 50px 20px
  .kiosk_cash_deposit
    padding 20px 20px
    min-height 200px
  .auth_code_title
    font-size 16px
    text-align center
    font-family 'Open Sans SemiBold'
  .auth_code_desc
    font-size 14px
    text-align center
    line-height normal
  .token
    margin 10px 0 5px 0
    padding 10px 20px
    border-radius 5px
    border 1px solid #003764
    font-size 22px
    letter-spacing: 1px
    text-align center
    font-family 'Open Sans SemiBold'

.countDownHolder
  position: relative
  align-items: center
  justify-content: center
  display: flex
  padding 0 0 30px 0
  .counter
    padding-left 10px
    font-size 16x
    text-align center
    font-family 'Open Sans SemiBold'
</style>



// WEBPACK FOOTER //
// src/components/account/DepositAtKiosk.vue